shared-paginate
  script(type="typescript").
    this.mixin('paginate');
